import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import defaultOgImage from "../images/og-image.png"

export const SeoBase = ({
  siteMetadata,
  title,
  description,
  lang,
  canonicalUrlPath,
  image,
}) => {
  const fullTitle =
    title && title !== siteMetadata.title
      ? `${title} | ${siteMetadata.title}`
      : siteMetadata.title
  const metaDescription = description || siteMetadata.description
  const metaLang = lang || siteMetadata.locale
  const metaAuthor = siteMetadata.author

  const metaKeywords = siteMetadata.keywords

  const linkCanonicalUrl = canonicalUrlPath
    ? `${siteMetadata.siteUrl}${canonicalUrlPath}`
    : siteMetadata.siteUrl
  const metaOgType = "website"
  const metaOgImage = image || `${siteMetadata.siteUrl}${defaultOgImage}`

  return (
    <Helmet
      htmlAttributes={{
        lang: metaLang,
      }}
      title={fullTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `author`,
          content: metaAuthor,
        },
        {
          name: `keywords`,
          content: metaKeywords,
        },
        {
          property: `og:type`,
          content: metaOgType,
        },
        {
          property: `og:title`,
          content: fullTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: metaOgImage,
        },
        {
          property: `og:url`,
          content: linkCanonicalUrl,
        },
      ]}
      link={[
        {
          rel: "canonical",
          href: linkCanonicalUrl,
        },
      ]}
    ></Helmet>
  )
}
const SeoBaseDataProps = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string,
  canonicalUrlPath: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.string,
  authors: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  publishedTime: PropTypes.string,
  modifiedTime: PropTypes.string,
  scripts: PropTypes.arrayOf(PropTypes.object),
}
SeoBase.propTypes = {
  siteMetadata: PropTypes.shape({
    siteUrl: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    author: PropTypes.string,
    keywords: PropTypes.string,
    locale: PropTypes.string,
  }),
  ...SeoBaseDataProps,
}

export const Seo = (data) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
            title
            description
            author
            keywords
            locale
          }
        }
      }
    `
  )

  return <SeoBase siteMetadata={site.siteMetadata} {...data} />
}
Seo.propTypes = {
  data: PropTypes.shape({
    ...SeoBaseDataProps,
  }),
}
